import SuperRepository from '../superRepository'

export default new (class LandingsRepository extends SuperRepository {
  baseUri() {
    return 'landing'
  }
})()
